import axios from 'axios'
const state = {
    loading: false,
    loadingCom: false,
    suppliers: [],
    communication: [],
    payment: null,
    notes: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    },
    supplier: {
        data: {},
        id: null,
        name: null,
        image: null,
        account: null,
        communications: [],
        information: {
          code: {
            desc: "Barcode",
            value: "",
          },
          tax_number: {
            desc:"Tax Number",
            value:""
          },
          type: {
            desc:"Type",
            value:""
          },
          phone: {
            desc: "hr.employee.phone",
            value: "",
          },
          email: {
            desc: "hr.employee.email",
            value: "",
          },
          classification: {
            desc: "Classification",
            value: "",
          },
          mobile: {
            desc: "hr.employee.phone2",
            value: "",
          },
          address: {
            desc: "address",
            value: "",
          },
          group: {
            desc: "Group",
            value: "",
          },
          coin: {
            desc: "Currency",
            value: "",
          },
        }
    },
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 20,
            page: 1,
            per_page: 20,
        },
    }
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getLoadingCom(state) {
        return state.loadingCom;
    },
    getSupplier(state) {
        return state.supplier
    },
    getSuppliers(state) {
        return state.suppliers
    },
    getTableOptions(state) {
        return state.tableOptions
    },
    getCommunication(state) {
        return state.communication
    },
    getPayment(state) {
        return state.payment
    },
    getNotes(state) {
        return state.notes
    },
};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setLoadingCom(state, status) {
        state.loadingCom = status;
    },
    setCommunication(state, communication) {
        state.communication = communication;
    },
    setSupplier(state, supplier) {
        state.supplier.data = supplier;
        state.supplier.id = supplier.id;
        state.supplier.name = supplier.name;
        state.supplier.image = supplier.image;
        state.supplier.communications = supplier.communications;
        state.supplier.account = supplier.account;
        state.supplier.information.code.value = supplier.code;
        state.supplier.information.tax_number.value = supplier.tax_number;
        state.supplier.information.type.value = supplier.type;
        state.supplier.information.phone.value = supplier.phone;
        state.supplier.information.email.value = supplier.email;
        state.supplier.information.classification.value = supplier.classification;
        state.supplier.information.mobile.value = supplier.mobile;
        state.supplier.information.address.value = supplier.address;
        state.supplier.information.group.value = supplier.group.name;
        state.supplier.information.coin.value = supplier.coin.name;
    },
    setSuppliers(state, suppliers) {
        state.suppliers = suppliers
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    },
    setNotes(state, tableInfo) {
        state.notes.tableHeaders = tableInfo.tableHeaders
        state.notes.tableData = tableInfo.tableData
        state.notes.accessTableData = tableInfo.accessTableData
        state.notes.tableMeta.total = tableInfo.tableMeta.total
        state.notes.tableMeta.page = tableInfo.tableMeta.page
    },
};

const actions = {
    async fetchSuppliers({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/b2b/vendor", {
                params,
            });
            commit('setSuppliers', response.data.data)
            commit('setTableData', {
                tableHeaders: [
                    "name",
                    "phone",
                    "address",
                    "Group Name",
                    "Type",
                    "settings",
                ],
                tableData: response.data.data,
                accessTableData: [
                    ["name"],
                    ["phone"],
                    ["address"],
                    ["group","name"],
                    ["type"],
                ],
                tableMeta: {
                    total: response.data.meta.total,
                    page: response.data.meta.current_page,
                    per_page: response.data.meta.per_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchSupplier({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/b2b/vendor/${id}`);
            commit('setSupplier', response.data.data)
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    async fetchCommunication({ commit }, id) {
        try {
            commit('setLoadingCom', true)
            const response = await axios.get(`/b2b/vendor/${id}/communication`);
            commit('setCommunication', response.data.data)
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingCom', false)
        }
    },
    async fetchPayments({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/b2b/vendor/${id}/payment`);
            state.payment = response.data.data;
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    async fetchNotes({ commit }, queryParams) {
            try {
                commit('setLoadingStatus', true)
                let params = {};
                for (let key in queryParams) {
                    if (queryParams[key]) {
                        params[key] = queryParams[key];
                    }
                }
                if(!queryParams.paginated) params.paginated = queryParams.paginated;
                const response = await axios.get(`/b2b/vendor/${params.veId}/note`);
                commit('setNotes', {
                    tableHeaders: [
                        "date",
                        "title",
                        "Note",
                        "user name",
                        "settings",
                    ],
                    tableData: response.data.data,
                    accessTableData: [
                        ["created_at"],
                        ["title"],
                        ["note"],
                        ["user"],
                    ],
                    tableMeta: {
                        total: response.data.meta.total,
                        page: response.data.meta.current_page,
                    },
                })
            } catch (err) {
                console.log('err', err);
            } finally {
                commit('setLoadingStatus', false)
            }
        },
    postNewSupplier({ commit }, newSupplier) {
        return new Promise(async (resolve, reject) => {
            try {
                let form = new FormData();
                for (let key in newSupplier) {
                    if (newSupplier[key]) {
                        form.append(`${key}`, newSupplier[key])
                    }
                }
                newSupplier.id ? await axios.post(`/b2b/vendor/${newSupplier.id}`, form) : await axios.post("/b2b/vendor", form);
                resolve()
            }
            catch (err) {
                reject()
            }
        })
    },
}


export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}